import { ENTITY_TYPES } from '@sales-center/common'
import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { useGetEntityCloseReasonsOnMount } from '@user/store/salesFunnel'
import { useFormikContext } from 'formik'
import { useMemo } from 'react'

export function useData() {
  const { values, errors, touched } =
    useFormikContext<IAddOpportunityFormModel>()

  const { reasonDetail } = useGetEntityCloseReasonsOnMount({
    entityType: ENTITY_TYPES.Opportunity,
    salesFunnelId: Number(values?.salesFunnelId),
  })

  const closeLostReasons = useMemo(
    () => reasonDetail?.disqualifyReasons ?? [],
    [reasonDetail?.disqualifyReasons],
  )

  const allowManualDisqualifyReasons = useMemo(
    () => reasonDetail?.allowManualDisqualifyReasons,
    [reasonDetail?.allowManualDisqualifyReasons],
  )

  const customReasonError = Boolean(
    errors.closedLostCustomReason && touched.closedLostCustomReason,
  )
  const customReasonErrorTxt = customReasonError
    ? errors.closedLostCustomReason
    : ''

  const reasonIdError = Boolean(
    errors.closedLostReasonId && touched.closedLostReasonId,
  )
  const reasonIdErrorTxt = reasonIdError ? errors.closedLostReasonId : ''

  return {
    closeLostReasons,
    allowManualDisqualifyReasons,
    customReasonError,
    customReasonErrorTxt,
    reasonIdError,
    reasonIdErrorTxt,
    closedLostReasonId: values?.closedLostReasonId,
  }
}
